"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_select_1 = __importDefault(require("vue-select"));
const bmk_ui_framework_1 = require("@biomemakers/bmk_ui_framework");
const bmk_ui_framework_2 = __importDefault(require("@biomemakers/bmk_ui_framework"));
const lucide_vue_next_1 = require("lucide-vue-next");
const BasicLoaderSection_vue_1 = __importDefault(require("../TrialsResults/UI/Components/BasicLoaderSection.vue"));
const SummaryViewMAAEngine_vue_1 = __importDefault(require("./SummaryViewMAAEngine.vue"));
const SummaryView_vue_1 = __importDefault(require("./SummaryView.vue"));
var TrialReportType;
(function (TrialReportType) {
    TrialReportType["MAA"] = "maa";
    TrialReportType["BECROP"] = "becrop";
})(TrialReportType || (TrialReportType = {}));
let SummaryTrialView = class SummaryTrialView extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.raw_user = null;
        this.raw_study = null;
        this.raw_project_bag = null;
        this.raw_gheom = null;
        this.user = null;
        this.isLoaded = false;
    }
    get internal_theme() {
        if (this.theme)
            return this.theme;
        return this.$theme.current.value;
    }
    get reportType() {
        return this.report_type || TrialReportType.BECROP;
    }
    loaded() {
        this.isLoaded = true;
    }
    get versionInLoaded() {
        return !!this.reportType || false;
    }
    get showMAAComponent() {
        return this.versionInLoaded && this.reportType === TrialReportType.MAA;
    }
    get showBecropComponent() {
        return this.versionInLoaded && this.reportType === TrialReportType.BECROP;
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: null })
], SummaryTrialView.prototype, "theme", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: 'study' })
], SummaryTrialView.prototype, "type", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: null })
], SummaryTrialView.prototype, "report_type", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)()
], SummaryTrialView.prototype, "raw_would_rather_crops", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)()
], SummaryTrialView.prototype, "raw_user", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)()
], SummaryTrialView.prototype, "raw_study", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)()
], SummaryTrialView.prototype, "raw_project_bag", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)()
], SummaryTrialView.prototype, "raw_gheom", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)()
], SummaryTrialView.prototype, "sidebar_selected", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)()
], SummaryTrialView.prototype, "becrop_crops", void 0);
SummaryTrialView = __decorate([
    (0, vue_property_decorator_1.Options)({
        name: 'SummaryTrialView',
        components: {
            vSelect: vue_select_1.default,
            SummaryViewMAAEngine: SummaryViewMAAEngine_vue_1.default,
            BasicLoaderSection: BasicLoaderSection_vue_1.default,
            SummaryView: SummaryView_vue_1.default,
            ZeroMatchesSearch: bmk_ui_framework_2.default,
            Loader: bmk_ui_framework_1.Loader,
            ChevronDown: lucide_vue_next_1.ChevronDown,
            ArrowBottomIcon: bmk_ui_framework_1.ArrowBottomIcon
        },
    })
], SummaryTrialView);
exports.default = SummaryTrialView;
